import React from 'react';
import './FoundersNote.css';

const FoundersNote = () => {
  return (
    <section className="founders-note-section">
      <div className="founders-note-content">
        <h3>— FOUNDER'S NOTE</h3>
        <p>
          We started Cognitva in 2025 with a bold question:
        </p>
        <p className="quote">
          <b>'What if tomorrow's intelligence could be built once and reused everywhere?'</b>
        </p>
        <p className="para">
          With decades of leadership across AI, enterprise transformation, and compliance-heavy sectors, we saw the limits of siloed, reactive
          tools. What was missing wasn't another chatbot or dashboard — it was <strong>infrastructure</strong>; AI that could adapt to legal, healthcare, ESG & Energy,
          or finance, with context, trust, and speed.
        </p>
        <p className="para">
          So we built Cognitva CIP™ — a <strong>cross-industry intelligence platform</strong> designed to power decision-making at scale, while being
          modular, secure, and explainable.
        </p>
        <p className="para">
          Today, Cognitva isn't just a product. It's a movement — toward frictionless <strong>compliance, proactive intelligence, and enterprise
            clarity</strong>. Whether you're a litigator, a hospital admin, or a regulatory executive, our mission is to bring you copilots and insights that
          are <strong>immediate, contextual, and trustworthy</strong>.
        </p>
        <div className="signature">
          <p> <strong>— Divya Singh,</strong> CEO</p>
          <p><strong>— Ram B. Adhikari,</strong> CTO</p>
        </div>
      </div>
    </section>
  );
};

export default FoundersNote; 